import type { ScopeSourceDefinition } from '@ts-scope/interfaces'
import type { ScopeMode, ScopeStatus } from '@utils/stores/scoped-entry'

interface SourceVisit {
  changed: boolean
  isSamePage: boolean
}

export const sourceStartMode = (
  definition: Pick<ScopeSourceDefinition, 'keepOnRevisit'>,
  status: ScopeStatus,
  { changed, isSamePage }: SourceVisit,
): ScopeMode | null => {
  if (changed || status === 'idle' || status === 'error') return 'enter'
  if (status === 'loading' || isSamePage) return null

  return definition.keepOnRevisit ? 'refresh' : 'enter'
}
